export class ZipApiTimeoutError extends Error {
  constructor(message?: string) {
    super(message || `OCP API request timed out.`);
  }
}
